import { _ as rt, f as Yt, I as bt, g as qt, C as U } from "./NavigationDrawer.vue_vue_type_style_index_1_scoped_fd5bf7fb_lang-a9e75722.mjs";
import { defineComponent as ht, openBlock as P, createBlock as M, unref as b, normalizeProps as Gt, guardReactiveProps as Jt, withCtx as V, renderSlot as N, mergeProps as Kt, createCommentVNode as X, useCssVars as Qt, ref as Z, computed as Rt, watch as Ut, onMounted as Zt, nextTick as te, createElementBlock as st, createElementVNode as $t, normalizeClass as Tt, normalizeStyle as kt, createVNode as Ct, createTextVNode as tt, toDisplayString as et } from "vue";
import { a_ as ee, a$ as ne } from "./VTextarea-a9029832.mjs";
const ke = /* @__PURE__ */ rt(Yt, [["__scopeId", "data-v-1d359999"]]), Ce = /* @__PURE__ */ ht({
  setup(t) {
    return (e, n) => (P(), M(b(ee), Gt(Jt(e.$attrs)), {
      default: V(() => [
        N(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), oe = /* @__PURE__ */ ht({
  props: {
    iconHeight: {
      type: Number,
      default: 24
    },
    testId: {
      type: String,
      default: "1"
    }
  },
  setup(t) {
    return (e, n) => (P(), M(b(ne), Kt(e.$attrs, {
      "data-testid": `list-item-${t.testId}`
    }), {
      prepend: V(() => [
        N(e.$slots, "prepend", {}, () => [
          typeof e.$attrs["prepend-icon"] == "string" ? (P(), M(b(bt), {
            key: 0,
            color: "inherit",
            height: t.iconHeight,
            icon: e.$attrs["prepend-icon"]
          }, null, 8, ["height", "icon"])) : X("", !0)
        ], !0)
      ]),
      append: V(() => [
        N(e.$slots, "append", {}, () => [
          typeof e.$attrs["append-icon"] == "string" ? (P(), M(b(bt), {
            key: 0,
            color: "inherit",
            height: t.iconHeight,
            icon: e.$attrs["append-icon"]
          }, null, 8, ["height", "icon"])) : X("", !0)
        ], !0)
      ]),
      default: V(() => [
        N(e.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 16, ["data-testid"]));
  }
}), Le = /* @__PURE__ */ rt(oe, [["__scopeId", "data-v-85afe756"]]), _e = /* @__PURE__ */ rt(qt, [["__scopeId", "data-v-26f08c07"]]);
function J(t) {
  return t.split("-")[1];
}
function gt(t) {
  return t === "y" ? "height" : "width";
}
function I(t) {
  return t.split("-")[0];
}
function K(t) {
  return ["top", "bottom"].includes(I(t)) ? "x" : "y";
}
function Lt(t, e, n) {
  let { reference: o, floating: c } = t;
  const r = o.x + o.width / 2 - c.width / 2, i = o.y + o.height / 2 - c.height / 2, l = K(e), f = gt(l), s = o[f] / 2 - c[f] / 2, u = l === "x";
  let a;
  switch (I(e)) {
    case "top":
      a = { x: r, y: o.y - c.height };
      break;
    case "bottom":
      a = { x: r, y: o.y + o.height };
      break;
    case "right":
      a = { x: o.x + o.width, y: i };
      break;
    case "left":
      a = { x: o.x - c.width, y: i };
      break;
    default:
      a = { x: o.x, y: o.y };
  }
  switch (J(e)) {
    case "start":
      a[l] -= s * (n && u ? -1 : 1);
      break;
    case "end":
      a[l] += s * (n && u ? -1 : 1);
  }
  return a;
}
const ie = async (t, e, n) => {
  const { placement: o = "bottom", strategy: c = "absolute", middleware: r = [], platform: i } = n, l = r.filter(Boolean), f = await (i.isRTL == null ? void 0 : i.isRTL(e));
  let s = await i.getElementRects({ reference: t, floating: e, strategy: c }), { x: u, y: a } = Lt(s, o, f), d = o, p = {}, g = 0;
  for (let h = 0; h < l.length; h++) {
    const { name: m, fn: x } = l[h], { x: y, y: w, data: $, reset: v } = await x({ x: u, y: a, initialPlacement: o, placement: d, strategy: c, middlewareData: p, rects: s, platform: i, elements: { reference: t, floating: e } });
    u = y ?? u, a = w ?? a, p = { ...p, [m]: { ...p[m], ...$ } }, v && g <= 50 && (g++, typeof v == "object" && (v.placement && (d = v.placement), v.rects && (s = v.rects === !0 ? await i.getElementRects({ reference: t, floating: e, strategy: c }) : v.rects), { x: u, y: a } = Lt(s, d, f)), h = -1);
  }
  return { x: u, y: a, placement: d, strategy: c, middlewareData: p };
};
function Pt(t) {
  return typeof t != "number" ? function(e) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...e };
  }(t) : { top: t, right: t, bottom: t, left: t };
}
function ut(t) {
  return { ...t, top: t.y, left: t.x, right: t.x + t.width, bottom: t.y + t.height };
}
async function Ot(t, e) {
  var n;
  e === void 0 && (e = {});
  const { x: o, y: c, platform: r, rects: i, elements: l, strategy: f } = t, { boundary: s = "clippingAncestors", rootBoundary: u = "viewport", elementContext: a = "floating", altBoundary: d = !1, padding: p = 0 } = e, g = Pt(p), h = l[d ? a === "floating" ? "reference" : "floating" : a], m = ut(await r.getClippingRect({ element: (n = await (r.isElement == null ? void 0 : r.isElement(h))) == null || n ? h : h.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(l.floating)), boundary: s, rootBoundary: u, strategy: f })), x = a === "floating" ? { ...i.floating, x: o, y: c } : i.reference, y = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(l.floating)), w = await (r.isElement == null ? void 0 : r.isElement(y)) && await (r.getScale == null ? void 0 : r.getScale(y)) || { x: 1, y: 1 }, $ = ut(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: x, offsetParent: y, strategy: f }) : x);
  return { top: (m.top - $.top + g.top) / w.y, bottom: ($.bottom - m.bottom + g.bottom) / w.y, left: (m.left - $.left + g.left) / w.x, right: ($.right - m.right + g.right) / w.x };
}
const re = Math.min, le = Math.max;
function dt(t, e, n) {
  return le(t, re(e, n));
}
const ae = (t) => ({ name: "arrow", options: t, async fn(e) {
  const { element: n, padding: o = 0 } = t || {}, { x: c, y: r, placement: i, rects: l, platform: f } = e;
  if (n == null)
    return {};
  const s = Pt(o), u = { x: c, y: r }, a = K(i), d = gt(a), p = await f.getDimensions(n), g = a === "y" ? "top" : "left", h = a === "y" ? "bottom" : "right", m = l.reference[d] + l.reference[a] - u[a] - l.floating[d], x = u[a] - l.reference[a], y = await (f.getOffsetParent == null ? void 0 : f.getOffsetParent(n));
  let w = y ? a === "y" ? y.clientHeight || 0 : y.clientWidth || 0 : 0;
  w === 0 && (w = l.floating[d]);
  const $ = m / 2 - x / 2, v = s[g], L = w - p[d] - s[h], R = w / 2 - p[d] / 2 + $, S = dt(v, R, L), Q = J(i) != null && R != S && l.reference[d] / 2 - (R < v ? s[g] : s[h]) - p[d] / 2 < 0;
  return { [a]: u[a] - (Q ? R < v ? v - R : L - R : 0), data: { [a]: S, centerOffset: R - S } };
} }), ce = ["top", "right", "bottom", "left"];
ce.reduce((t, e) => t.concat(e, e + "-start", e + "-end"), []);
const se = { left: "right", right: "left", bottom: "top", top: "bottom" };
function ot(t) {
  return t.replace(/left|right|bottom|top/g, (e) => se[e]);
}
function fe(t, e, n) {
  n === void 0 && (n = !1);
  const o = J(t), c = K(t), r = gt(c);
  let i = c === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[r] > e.floating[r] && (i = ot(i)), { main: i, cross: ot(i) };
}
const ue = { start: "end", end: "start" };
function ft(t) {
  return t.replace(/start|end/g, (e) => ue[e]);
}
const de = function(t) {
  return t === void 0 && (t = {}), { name: "flip", options: t, async fn(e) {
    var n;
    const { placement: o, middlewareData: c, rects: r, initialPlacement: i, platform: l, elements: f } = e, { mainAxis: s = !0, crossAxis: u = !0, fallbackPlacements: a, fallbackStrategy: d = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: g = !0, ...h } = t, m = I(o), x = I(i) === i, y = await (l.isRTL == null ? void 0 : l.isRTL(f.floating)), w = a || (x || !g ? [ot(i)] : function(k) {
      const E = ot(k);
      return [ft(k), E, ft(E)];
    }(i));
    a || p === "none" || w.push(...function(k, E, W, O) {
      const D = J(k);
      let C = function(z, ct, jt) {
        const wt = ["left", "right"], vt = ["right", "left"], zt = ["top", "bottom"], Xt = ["bottom", "top"];
        switch (z) {
          case "top":
          case "bottom":
            return jt ? ct ? vt : wt : ct ? wt : vt;
          case "left":
          case "right":
            return ct ? zt : Xt;
          default:
            return [];
        }
      }(I(k), W === "start", O);
      return D && (C = C.map((z) => z + "-" + D), E && (C = C.concat(C.map(ft)))), C;
    }(i, g, p, y));
    const $ = [i, ...w], v = await Ot(e, h), L = [];
    let R = ((n = c.flip) == null ? void 0 : n.overflows) || [];
    if (s && L.push(v[m]), u) {
      const { main: k, cross: E } = fe(o, r, y);
      L.push(v[k], v[E]);
    }
    if (R = [...R, { placement: o, overflows: L }], !L.every((k) => k <= 0)) {
      var S, Q;
      const k = (((S = c.flip) == null ? void 0 : S.index) || 0) + 1, E = $[k];
      if (E)
        return { data: { index: k, overflows: R }, reset: { placement: E } };
      let W = (Q = R.filter((O) => O.overflows[0] <= 0).sort((O, D) => O.overflows[1] - D.overflows[1])[0]) == null ? void 0 : Q.placement;
      if (!W)
        switch (d) {
          case "bestFit": {
            var xt;
            const O = (xt = R.map((D) => [D.placement, D.overflows.filter((C) => C > 0).reduce((C, z) => C + z, 0)]).sort((D, C) => D[1] - C[1])[0]) == null ? void 0 : xt[0];
            O && (W = O);
            break;
          }
          case "initialPlacement":
            W = i;
        }
      if (o !== W)
        return { reset: { placement: W } };
    }
    return {};
  } };
}, pe = function(t) {
  return t === void 0 && (t = 0), { name: "offset", options: t, async fn(e) {
    const { x: n, y: o } = e, c = await async function(r, i) {
      const { placement: l, platform: f, elements: s } = r, u = await (f.isRTL == null ? void 0 : f.isRTL(s.floating)), a = I(l), d = J(l), p = K(l) === "x", g = ["left", "top"].includes(a) ? -1 : 1, h = u && p ? -1 : 1, m = typeof i == "function" ? i(r) : i;
      let { mainAxis: x, crossAxis: y, alignmentAxis: w } = typeof m == "number" ? { mainAxis: m, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...m };
      return d && typeof w == "number" && (y = d === "end" ? -1 * w : w), p ? { x: y * h, y: x * g } : { x: x * g, y: y * h };
    }(e, t);
    return { x: n + c.x, y: o + c.y, data: c };
  } };
};
function me(t) {
  return t === "x" ? "y" : "x";
}
const he = function(t) {
  return t === void 0 && (t = {}), { name: "shift", options: t, async fn(e) {
    const { x: n, y: o, placement: c } = e, { mainAxis: r = !0, crossAxis: i = !1, limiter: l = { fn: (m) => {
      let { x, y } = m;
      return { x, y };
    } }, ...f } = t, s = { x: n, y: o }, u = await Ot(e, f), a = K(I(c)), d = me(a);
    let p = s[a], g = s[d];
    if (r) {
      const m = a === "y" ? "bottom" : "right";
      p = dt(p + u[a === "y" ? "top" : "left"], p, p - u[m]);
    }
    if (i) {
      const m = d === "y" ? "bottom" : "right";
      g = dt(g + u[d === "y" ? "top" : "left"], g, g - u[m]);
    }
    const h = l.fn({ ...e, [a]: p, [d]: g });
    return { ...h, data: { x: h.x - n, y: h.y - o } };
  } };
};
function T(t) {
  var e;
  return ((e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function _(t) {
  return T(t).getComputedStyle(t);
}
const _t = Math.min, Y = Math.max, it = Math.round;
function Vt(t) {
  const e = _(t);
  let n = parseFloat(e.width), o = parseFloat(e.height);
  const c = t.offsetWidth, r = t.offsetHeight, i = it(n) !== c || it(o) !== r;
  return i && (n = c, o = r), { width: n, height: o, fallback: i };
}
function F(t) {
  return Ht(t) ? (t.nodeName || "").toLowerCase() : "";
}
let nt;
function Bt() {
  if (nt)
    return nt;
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? (nt = t.brands.map((e) => e.brand + "/" + e.version).join(" "), nt) : navigator.userAgent;
}
function A(t) {
  return t instanceof T(t).HTMLElement;
}
function B(t) {
  return t instanceof T(t).Element;
}
function Ht(t) {
  return t instanceof T(t).Node;
}
function At(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof T(t).ShadowRoot || t instanceof ShadowRoot;
}
function lt(t) {
  const { overflow: e, overflowX: n, overflowY: o, display: c } = _(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && !["inline", "contents"].includes(c);
}
function ge(t) {
  return ["table", "td", "th"].includes(F(t));
}
function pt(t) {
  const e = /firefox/i.test(Bt()), n = _(t), o = n.backdropFilter || n.WebkitBackdropFilter;
  return n.transform !== "none" || n.perspective !== "none" || !!o && o !== "none" || e && n.willChange === "filter" || e && !!n.filter && n.filter !== "none" || ["transform", "perspective"].some((c) => n.willChange.includes(c)) || ["paint", "layout", "strict", "content"].some((c) => {
    const r = n.contain;
    return r != null && r.includes(c);
  });
}
function mt() {
  return /^((?!chrome|android).)*safari/i.test(Bt());
}
function yt(t) {
  return ["html", "body", "#document"].includes(F(t));
}
function Ft(t) {
  return B(t) ? t : t.contextElement;
}
const Wt = { x: 1, y: 1 };
function j(t) {
  const e = Ft(t);
  if (!A(e))
    return Wt;
  const n = e.getBoundingClientRect(), { width: o, height: c, fallback: r } = Vt(e);
  let i = (r ? it(n.width) : n.width) / o, l = (r ? it(n.height) : n.height) / c;
  return i && Number.isFinite(i) || (i = 1), l && Number.isFinite(l) || (l = 1), { x: i, y: l };
}
function q(t, e, n, o) {
  var c, r;
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const i = t.getBoundingClientRect(), l = Ft(t);
  let f = Wt;
  e && (o ? B(o) && (f = j(o)) : f = j(t));
  const s = l ? T(l) : window, u = mt() && n;
  let a = (i.left + (u && ((c = s.visualViewport) == null ? void 0 : c.offsetLeft) || 0)) / f.x, d = (i.top + (u && ((r = s.visualViewport) == null ? void 0 : r.offsetTop) || 0)) / f.y, p = i.width / f.x, g = i.height / f.y;
  if (l) {
    const h = T(l), m = o && B(o) ? T(o) : o;
    let x = h.frameElement;
    for (; x && o && m !== h; ) {
      const y = j(x), w = x.getBoundingClientRect(), $ = getComputedStyle(x);
      w.x += (x.clientLeft + parseFloat($.paddingLeft)) * y.x, w.y += (x.clientTop + parseFloat($.paddingTop)) * y.y, a *= y.x, d *= y.y, p *= y.x, g *= y.y, a += w.x, d += w.y, x = T(x).frameElement;
    }
  }
  return { width: p, height: g, top: d, right: a + p, bottom: d + g, left: a, x: a, y: d };
}
function H(t) {
  return ((Ht(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function at(t) {
  return B(t) ? { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop } : { scrollLeft: t.pageXOffset, scrollTop: t.pageYOffset };
}
function It(t) {
  return q(H(t)).left + at(t).scrollLeft;
}
function G(t) {
  if (F(t) === "html")
    return t;
  const e = t.assignedSlot || t.parentNode || At(t) && t.host || H(t);
  return At(e) ? e.host : e;
}
function Mt(t) {
  const e = G(t);
  return yt(e) ? e.ownerDocument.body : A(e) && lt(e) ? e : Mt(e);
}
function Nt(t, e) {
  var n;
  e === void 0 && (e = []);
  const o = Mt(t), c = o === ((n = t.ownerDocument) == null ? void 0 : n.body), r = T(o);
  return c ? e.concat(r, r.visualViewport || [], lt(o) ? o : []) : e.concat(o, Nt(o));
}
function St(t, e, n) {
  let o;
  if (e === "viewport")
    o = function(i, l) {
      const f = T(i), s = H(i), u = f.visualViewport;
      let a = s.clientWidth, d = s.clientHeight, p = 0, g = 0;
      if (u) {
        a = u.width, d = u.height;
        const h = mt();
        (!h || h && l === "fixed") && (p = u.offsetLeft, g = u.offsetTop);
      }
      return { width: a, height: d, x: p, y: g };
    }(t, n);
  else if (e === "document")
    o = function(i) {
      const l = H(i), f = at(i), s = i.ownerDocument.body, u = Y(l.scrollWidth, l.clientWidth, s.scrollWidth, s.clientWidth), a = Y(l.scrollHeight, l.clientHeight, s.scrollHeight, s.clientHeight);
      let d = -f.scrollLeft + It(i);
      const p = -f.scrollTop;
      return _(s).direction === "rtl" && (d += Y(l.clientWidth, s.clientWidth) - u), { width: u, height: a, x: d, y: p };
    }(H(t));
  else if (B(e))
    o = function(i, l) {
      const f = q(i, !0, l === "fixed"), s = f.top + i.clientTop, u = f.left + i.clientLeft, a = A(i) ? j(i) : { x: 1, y: 1 };
      return { width: i.clientWidth * a.x, height: i.clientHeight * a.y, x: u * a.x, y: s * a.y };
    }(e, n);
  else {
    const i = { ...e };
    if (mt()) {
      var c, r;
      const l = T(t);
      i.x -= ((c = l.visualViewport) == null ? void 0 : c.offsetLeft) || 0, i.y -= ((r = l.visualViewport) == null ? void 0 : r.offsetTop) || 0;
    }
    o = i;
  }
  return ut(o);
}
function Et(t, e) {
  return A(t) && _(t).position !== "fixed" ? e ? e(t) : t.offsetParent : null;
}
function Dt(t, e) {
  const n = T(t);
  let o = Et(t, e);
  for (; o && ge(o) && _(o).position === "static"; )
    o = Et(o, e);
  return o && (F(o) === "html" || F(o) === "body" && _(o).position === "static" && !pt(o)) ? n : o || function(c) {
    let r = G(c);
    for (; A(r) && !yt(r); ) {
      if (pt(r))
        return r;
      r = G(r);
    }
    return null;
  }(t) || n;
}
function ye(t, e, n) {
  const o = A(e), c = H(e), r = q(t, !0, n === "fixed", e);
  let i = { scrollLeft: 0, scrollTop: 0 };
  const l = { x: 0, y: 0 };
  if (o || !o && n !== "fixed")
    if ((F(e) !== "body" || lt(c)) && (i = at(e)), A(e)) {
      const f = q(e, !0);
      l.x = f.x + e.clientLeft, l.y = f.y + e.clientTop;
    } else
      c && (l.x = It(c));
  return { x: r.left + i.scrollLeft - l.x, y: r.top + i.scrollTop - l.y, width: r.width, height: r.height };
}
const xe = { getClippingRect: function(t) {
  let { element: e, boundary: n, rootBoundary: o, strategy: c } = t;
  const r = n === "clippingAncestors" ? function(s, u) {
    const a = u.get(s);
    if (a)
      return a;
    let d = Nt(s).filter((m) => B(m) && F(m) !== "body"), p = null;
    const g = _(s).position === "fixed";
    let h = g ? G(s) : s;
    for (; B(h) && !yt(h); ) {
      const m = _(h), x = pt(h);
      m.position === "fixed" ? p = null : (g ? x || p : x || m.position !== "static" || !p || !["absolute", "fixed"].includes(p.position)) ? p = m : d = d.filter((y) => y !== h), h = G(h);
    }
    return u.set(s, d), d;
  }(e, this._c) : [].concat(n), i = [...r, o], l = i[0], f = i.reduce((s, u) => {
    const a = St(e, u, c);
    return s.top = Y(a.top, s.top), s.right = _t(a.right, s.right), s.bottom = _t(a.bottom, s.bottom), s.left = Y(a.left, s.left), s;
  }, St(e, l, c));
  return { width: f.right - f.left, height: f.bottom - f.top, x: f.left, y: f.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
  let { rect: e, offsetParent: n, strategy: o } = t;
  const c = A(n), r = H(n);
  if (n === r)
    return e;
  let i = { scrollLeft: 0, scrollTop: 0 }, l = { x: 1, y: 1 };
  const f = { x: 0, y: 0 };
  if ((c || !c && o !== "fixed") && ((F(n) !== "body" || lt(r)) && (i = at(n)), A(n))) {
    const s = q(n);
    l = j(n), f.x = s.x + n.clientLeft, f.y = s.y + n.clientTop;
  }
  return { width: e.width * l.x, height: e.height * l.y, x: e.x * l.x - i.scrollLeft * l.x + f.x, y: e.y * l.y - i.scrollTop * l.y + f.y };
}, isElement: B, getDimensions: function(t) {
  return A(t) ? Vt(t) : t.getBoundingClientRect();
}, getOffsetParent: Dt, getDocumentElement: H, getScale: j, async getElementRects(t) {
  let { reference: e, floating: n, strategy: o } = t;
  const c = this.getOffsetParent || Dt, r = this.getDimensions;
  return { reference: ye(e, await c(n), o), floating: { x: 0, y: 0, ...await r(n) } };
}, getClientRects: (t) => Array.from(t.getClientRects()), isRTL: (t) => _(t).direction === "rtl" }, we = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), c = { platform: xe, ...n }, r = { ...c.platform, _c: o };
  return ie(t, e, { ...c, platform: r });
}, ve = {
  key: 0,
  class: "c-tooltip__wrapper d-flex flex-column"
}, be = /* @__PURE__ */ ht({
  props: {
    action: {
      type: String,
      default: null
    },
    content: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    placement: {
      type: String,
      default: "bottom"
    },
    color: {
      type: String,
      default: null
    },
    textColor: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    width: {
      type: String,
      default: "360"
    },
    show: {
      type: Boolean,
      default: !1
    },
    manual: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["handleActionClick"],
  setup(t, { emit: e }) {
    const n = t;
    Qt((m) => ({
      c7d711f6: b(h)
    }));
    const o = Z(), c = Z(), r = Z(), i = Z(!0);
    let l = 0;
    const f = Rt(() => n.content && n.title), s = async () => {
      var v, L, R, S;
      const { x: m, y: x, middlewareData: y, placement: w } = await we(
        b(o),
        b(c),
        {
          placement: n.placement,
          middleware: [
            pe(8),
            de(),
            he({ padding: 5 }),
            ae({ element: b(r) })
          ]
        }
      );
      Object.assign(b(c).style, {
        left: `${m}px`,
        top: `${x}px`
      });
      const $ = String(
        {
          left: "right",
          right: "left",
          bottom: "top",
          top: "bottom"
        }[w.split("-")[0]]
      );
      Object.assign(b(r).style, {
        left: (v = y.arrow) != null && v.x ? `${(L = y.arrow) == null ? void 0 : L.x}px` : "",
        top: (R = y.arrow) != null && R.y ? `${(S = y.arrow) == null ? void 0 : S.y}px` : "",
        [$]: "-4px"
      });
    }, u = () => {
      n.disabled || (l && clearTimeout(l), i.value = !1, s());
    }, a = () => {
      n.disabled || (f.value ? l = setTimeout(() => {
        i.value = !0;
      }, 300) : i.value = !0);
    }, d = () => {
      n.manual || u();
    }, p = () => {
      n.manual || a();
    };
    Ut(
      () => n.show,
      (m) => {
        m ? u() : a();
      }
    );
    const g = () => {
      e("handleActionClick");
    };
    Zt(() => {
      te(() => {
        setTimeout(() => {
          n.show && u();
        }, 100);
      });
    });
    const h = Rt(() => n.width + "px");
    return (m, x) => (P(), st("div", null, [
      $t("div", {
        "data-testid": "tooltip",
        class: "c-tooltip",
        onMouseenter: d,
        onMouseleave: p,
        onFocus: d,
        onBlur: p,
        ref_key: "parentRef",
        ref: o
      }, [
        N(m.$slots, "default", {}, void 0, !0),
        n.disabled ? X("", !0) : (P(), st("div", {
          key: 0,
          class: Tt([
            "c-tooltip__content",
            { "c-tooltip__content--rich": b(f) },
            { "d-none": i.value }
          ]),
          style: kt([
            { "background-color": t.color, border: t.color, color: t.textColor }
          ]),
          ref_key: "contentRef",
          ref: c
        }, [
          b(f) ? (P(), st("div", ve, [
            Ct(b(U), {
              variant: "body-3-600",
              class: "mb-1",
              "color-class": "cta"
            }, {
              default: V(() => [
                tt(et(n.title), 1)
              ]),
              _: 1
            }),
            Ct(b(U), {
              variant: "body-3-400",
              "color-class": "universal-gray"
            }, {
              default: V(() => [
                tt(et(n.content), 1)
              ]),
              _: 1
            }),
            n.action ? (P(), M(b(U), {
              key: 0,
              "color-class": "highlight-panel",
              pointer: "",
              onClick: g,
              class: "button-action mb-2 mt-5",
              variant: "body-2-600"
            }, {
              default: V(() => [
                tt(et(n.action), 1)
              ]),
              _: 1
            })) : X("", !0),
            n.action ? X("", !0) : N(m.$slots, "actionSlot", { key: 1 }, void 0, !0)
          ])) : (P(), M(b(U), {
            key: 1,
            variant: "body-3-400",
            "color-class": "cta"
          }, {
            default: V(() => [
              tt(et(n.content), 1)
            ]),
            _: 1
          })),
          $t("div", {
            class: Tt(["c-tooltip__arrow", { "c-tooltip__arrow--rich": b(f) }]),
            style: kt([{ "background-color": t.color, border: t.color }]),
            ref_key: "arrowRef",
            ref: r
          }, null, 6)
        ], 6))
      ], 544)
    ]));
  }
}), Ae = /* @__PURE__ */ rt(be, [["__scopeId", "data-v-841f830f"]]);
export {
  _e as C,
  Ce as _,
  ke as a,
  Ae as b,
  Le as c
};
